export enum CurrencyNameId {
  ISO3_LETTER = 'iso3letter',
}
